import { mount } from 'svelte';
import App from './SelfAssessment.svelte';
const target = document.querySelector('#self-assessment-block');
if (target) {
    mount(App, { target });
}
